import {InitPage} from "../index";
import LiveClock from "../controls/live_clock";

declare var App: any;
declare var storeLocation: string;

class LiveSalesOrders {
  salesOrdersChannel: any;
  zoneId: any;

  constructor() {
    this.zoneId = $('#zone_id').val();
    
    this.salesOrdersChannel = App.cable.subscriptions.create(
      // Connection configuration
      {
        channel: "SalesOrdersChannel",
        tenant_code: storeLocation,
        zone_id: this.zoneId
      },
      // Pass in connection callbacks
      {
        connected() { /* Called when the subscription is ready for use on the server */ },
        disconnected() { /* Called when the subscription has been terminated by the server */ },
        received: (data: any) => this.updateLineByLine(data)
      }
    );

    // Initialize the Clock
    new LiveClock();

    $(document).on('click', '.clickable-table-row', function() {
      window.open($(this).data('href'), '_blank');
    });
  }

  updateEntireTables(data) {
    $.ajax({
      dataType: "jsonp",
      url: `live_sales_orders.js?zone_id=${this.zoneId}`
    });
  }

  updateLineByLine(data) {
    const { so_process: soProcess } = data;

    // Update single order
    $.ajax({
      dataType: "jsonp",
      url: `live_sales_order/${soProcess.id}.js`
    });

    // Update header statistics
    $.ajax({
      dataType: "jsonp",
      url: `live_sales_orders_statistics.js?zone_id=${this.zoneId}`
    });
  }

  startClock() {
    setInterval(this.updateClock, 1000);
  }

  updateClock() {
    const timeOptions = {
      timeZone: 'America/Los_Angeles',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
    };
    const dateOptions = {
      timeZone: 'America/Los_Angeles',
      month: 'long', weekday: 'short', day: 'numeric',
    };

    const timeFormatter = new Intl.DateTimeFormat([], timeOptions);

    const dateFormatter = new Intl.DateTimeFormat(['en-US'], dateOptions);

    $('#live_time').html(timeFormatter.format(new Date()));
    $('#live_date').html(`${dateFormatter.format(new Date())}th`);
  }

  generateTableRow(soProcess) {

  }
}

export function LoadPage() {
  InitPage("live_so_processes", () => {
    const m = new LiveSalesOrders();
  });
}
